// Seçim drawer'ları için sistem değişkeni listelerinden sayfalı arama
// fonksiyonları (usePagedSearch `fetchPage` imzası).

// Sunucudan sayfa başına gelen kayıt
export const PICKER_PAGE_SIZE = 30;

/**
 * @param {Function} trigger - RTK mutation tetikleyicisi (listFoods, listMedicineTemplates …)
 * @param {string} token
 * @param {(data: object) => object[]} pickItems - yanıt `data`sından kayıt dizisi
 * @param {(item: object) => {key, value, title, subtitle?, raw?}} toOption
 */
export const makeFetchPage = (trigger, token, pickItems, toOption) => async ({ query, page }) => {
  const res = await trigger({
    token,
    status: "active",
    query: query || undefined,
    page,
    limit: PICKER_PAGE_SIZE,
  }).unwrap();
  const items = pickItems(res?.data || {}).map(toOption).filter((o) => o && o.value);
  return { items, hasMore: page < (res?.data?.pagination?.pages || 0) };
};

export const pickFoods = (d) => d.foods || d.items || [];
export const foodOption = (f) => ({
  key: String(f._id || f.id),
  value: f.name,
  title: f.name,
  raw: f,
});

export const pickMedicines = (d) => d.items || d.medicines || [];
export const medicineOption = (m) => ({
  key: String(m._id),
  value: m.name,
  title: m.name,
  raw: m,
});
